import { getRouteObjectList, withLayout } from '../router/util/router.helper'
import { RouteObjectList } from '../router/model/Route'
import { RouterLayout } from '../router/component/layout/RouterLayout'
import { myTeamIds } from '../router/model/RouteId'

export const myTeamRoutes: RouteObjectList = [
  withLayout({
    layout: <RouterLayout />,
    routes: getRouteObjectList(myTeamIds),
  }),
]
